/* eslint-disable camelcase */
/* eslint-disable no-use-before-define */
import {feLogger as _feLogger} from './';
import fpsLogger from './performance/fpsLogger';
import {CaptureError} from './performance/captureError';
import {EditorInputDelay} from './performance/editorInputDelay';
import {RTEOpLossRatio} from './performance/rteOpLossRatio';
import {FirstPaint} from './performance/firstPaint';
import {Publish} from './performance/publish';
import {EditorPaint} from './performance/editorPaint';
import {ENVIRONMENT_LEVEL} from '@/Constant';
import {DocPagePaint} from './performance/docPagePaint';
import {EditorCrash} from './performance/editorCrash';
import {Comment} from './performance/comment';
import {EditorFile} from './performance/editorFile';
import {SourceAndApiError} from './performance/sourceAndApiError';
import {UnderlineComment} from './performance/underlineComment';
import {LoadTimeDetailed} from './performance/loadTimeDetailed';
import {matchPath} from 'react-router-dom';
import routers from '@/config/routers';
import {CompRender} from './performance/compRender';

export type {CategoryType} from './performance/editorPaint';
export class LogBuffer {
    pool: {[key: string]: any} = {};
    add = <T>(key: string, data: T) => {
        if (!this.pool[key]) {
            this.pool[key] = [];
        }
        this.pool[key].push(data);
    };
    log = (key?: string) => {
        if (key) {
            console.log(this.pool[key]);
        }
        console.log(this.pool);
    };
    get = (key?: string) => {
        if (key) {
            return this.pool[key];
        }
        return this.pool;
    };
    set = (key: string, value: any) => {
        this.pool[key] = value;
    };
    clear = (key?: string) => {
        if (key) {
            delete this.pool[key];
            return;
        }
        this.pool = {};
    };
}

interface DocInfo {
    spaceGuid?: string;
    groupGuid?: string;
    repositoryGuid?: string;
    docGuid?: string;
}
function getUrlInfo(url: string) {
    const match = matchPath<DocInfo>(url, {
        path: [
            routers.Knowledge.path,
            routers.Knowledge.mobilePath,
        ],
    });

    if (!match) {
        return null;
    }
    const {
        spaceGuid = '',
        groupGuid = '',
        repositoryGuid = '',
        docGuid = '',
    } = match.params;
    return {
        spaceId: spaceGuid,
        groupId: groupGuid,
        repoId: repositoryGuid,
        pageId: docGuid,
    };
}

interface FeloggerProp {
    id: string;
    data?: any;
    repoData?: {pageId: string, repoId: string, groupId: string} | null;
}
const feLogger = ({
    id,
    data,
    repoData,
}: FeloggerProp) => {
    repoData = repoData || getUrlInfo(location.pathname);

    const logData = {
        rep_id: id,
        rep_params: {
            page_id: repoData?.pageId || '',
            kb_id: repoData?.repoId || '',
            kb_org_id: repoData?.groupId || '',
            ...data,
        },
        rep_type: 'click',
    };
    setTimeout(() => {
        try {
            _feLogger(logData);
        } catch {
            console.error('performance feLogger 报错');
        }
    }, 0);
};

type GetEditorOpVersionFuc = ((flag?: boolean) => string) | null;
export class PerformanceLogger {

    feLogger: (data: FeloggerProp) => void;
    captureError: CaptureError;
    editorInputDelay: EditorInputDelay;
    rteOpLossRatio: RTEOpLossRatio;
    firstPaint: FirstPaint;
    publish: Publish;
    editorPaint: EditorPaint;
    docPagePaint: DocPagePaint;
    editorCrash: EditorCrash;
    comment: Comment;
    editorFile: EditorFile;
    sourceAndApiError: SourceAndApiError;
    underlineComment: UnderlineComment;
    loadTimeDetailed: LoadTimeDetailed;
    compRender: CompRender;
    buffer: LogBuffer;
    logLevel = process.env.REACT_APP_ENVIRONMENT;

    constructor() {
        this.feLogger = feLogger;
        this.captureError = new CaptureError(this);
        this.editorInputDelay = new EditorInputDelay(this);
        this.rteOpLossRatio = new RTEOpLossRatio(this);
        this.firstPaint = new FirstPaint(this);
        this.publish = new Publish(this);
        this.editorPaint = new EditorPaint(this);
        this.docPagePaint = new DocPagePaint(this);
        this.editorCrash = new EditorCrash(this);
        this.comment = new Comment(this);
        this.editorFile = new EditorFile(this);
        this.sourceAndApiError = new SourceAndApiError(this);
        this.underlineComment = new UnderlineComment(this);
        this.loadTimeDetailed = new LoadTimeDetailed(this);
        this.compRender = new CompRender(this);

        // 需要注册
        const wikiGlobal = (window as any).wikiGlobal || {};
        wikiGlobal.docPaintLog = this.docPagePaint.logOverTime;
        if (wikiGlobal.docPaintNeedLogAgain) {
            this.docPagePaint.logOverTime();
            wikiGlobal.docPaintNeedLogAgain = false;
        }
        this.buffer = new LogBuffer();
    }

    getEditorOpVersion: GetEditorOpVersionFuc = () => '';
    // isDev = isDev;

    bindGetEditorVersion = (fuc: GetEditorOpVersionFuc) => {
        this.getEditorOpVersion = fuc;
    };

    getOpVersionInfo = (changeMode?: boolean) => {
        try {
            const {getEditorOpVersion} = this;
            const opVersion = getEditorOpVersion ? getEditorOpVersion(changeMode) : null;
            return JSON.stringify(opVersion);
        } catch (e) {
            return '';
        }
    };

    log = (key?: string) => {
        const logs = {
            [`${this.captureError.key}`]: this.captureError.getData(),
            [`${this.editorInputDelay.key}`]: this.editorInputDelay.getData(),
            [`${this.rteOpLossRatio.key}`]: this.rteOpLossRatio.getData(),
            [`${this.firstPaint.key}`]: this.firstPaint.getData(),
            [`${this.publish.key}`]: this.publish.getData(),
            [`${this.docPagePaint.key}`]: this.docPagePaint.getData(),
            [`${this.compRender.key}`]: this.compRender.getData(),
        };
        this.buffer.clear(key);
        return logs;
    };

}

export {PROFILER_KEY} from './performance/compRender';

export const perfLogger = new PerformanceLogger();

// 线上环境不暴露
if (process.env.REACT_APP_ENVIRONMENT !== ENVIRONMENT_LEVEL.online) {
    (window as any).perfLogger = perfLogger;
    (window as any).fpsLogger = fpsLogger;
}

